import type { SearchEntryFragment } from '#graphql-operations'

export async function useSearchQuery() {
  const { locale } = useI18n()

  const optionsVariables = computed(() => ({
    section: ['search'],
    site: [locale.value],
  }))

  const response = await useAsyncGraphqlQuery('Entry', optionsVariables, {
    transform: input => input.data.entry as SearchEntryFragment,
  })

  return response
}
